/** E-mails autorizados ao botão Calibrar na sessão de Suporte conectado. */
export const SUPPORT_CALIBRAR_ALLOWED_EMAILS = [
  'cristiane.santos@motomco.com.br',
  'gecilyn.brito@motomco.com.br',
  'bruna.prestes@motomco.com.br',
  'vanessa.santos@motomco.com.br',
  'gabriel.sa@motomco.com.br',
  'alan.aliske@motomco.com.br',
  'vilmar.ferreira@motomco.com.br',
  'engenharia2@locsolution.com',
];

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export const canUseSupportCalibrar = (user) =>
  user?.permission?.support?.write === true
  && SUPPORT_CALIBRAR_ALLOWED_EMAILS.includes(normalizeEmail(user?.email));
